import { useTranslation } from 'react-i18next';
import {
  SectionWrapper,
  StyledHr,
  ContentWrapper,
  TextBox2,
  SectionContainer,
} from './AuditSix.style';

const AuditSix = () => {
  const { t } = useTranslation('audit');
  return (
    <SectionContainer>
      <SectionWrapper>
        <h1>{t('auditSix.title')}</h1>
        <StyledHr />
      </SectionWrapper>

      <ContentWrapper>
        <TextBox2>
          <div className="grid-content">
            <ul>
              <li>{t('auditSix.ulOne.liOne')}</li>
              <li>{t('auditSix.ulOne.liTwo')}</li>
              <li>{t('auditSix.ulOne.liThree')}</li>
              <li>{t('auditSix.ulOne.liFour')}</li>
            </ul>
          </div>
          <div className="grid-content">
            <ul>
              <li>{t('auditSix.ulTwo.liOne')}</li>
              <li>{t('auditSix.ulTwo.liTwo')}</li>
              <li>{t('auditSix.ulTwo.liThree')}</li>
              <li>{t('auditSix.ulTwo.liFour')}</li>
            </ul>
          </div>
          <div className="grid-content">
            <ul>
              <li>{t('auditSix.ulThree.liOne')}</li>
              <li>{t('auditSix.ulThree.liTwo')}</li>
              <li>{t('auditSix.ulThree.liThree')}</li>
              <li>{t('auditSix.ulThree.liFour')}</li>
              <li>{t('auditSix.ulThree.liFive')}</li>
            </ul>
          </div>
        </TextBox2>
      </ContentWrapper>
    </SectionContainer>
  );
};

export default AuditSix;
